import React, { useEffect, useState } from 'react';
import { IFutureOrder } from '../../../../sp-types/FutureOrderType';
import { Product } from '../../../../sp-types/productType';
import { ExpectedDeliveries } from './ExpectedDeliveries/ExpectedDeliveries';
import { FOModifyProductDeliveriesButtonSection } from './FillOrderDetailsButtonSection';
import { OrderDetailsInputFields } from './OrderDetailsInputFields/OrderDetailsInputFields';
import { createFutureOrder } from '../../../../sp-firebase/futureOrderFB';

interface Props {
  nextAction: (_newId?: string) => void;
  backAction: () => void;
  accountId: string;
  editedFutureOrder: IFutureOrder;
  setEditedFutureOrder: (_value: IFutureOrder) => void;
  allProducts: Product[] | undefined | null;
}

export const FOModifyProductDeliveries: React.FC<Props> = ({
  backAction,
  nextAction,
  accountId,
  allProducts: products,
  editedFutureOrder,
  setEditedFutureOrder,
}) => {
  const [isNextLoading, setIsNextLoading] = useState(false);

  return editedFutureOrder ? (
    <div className="flex flex-1 flex-col pt-2 h-full justify-between overflow-auto relative">
      <div className="pl-6">
        <h6 className="text-red text-lg">Edit product details</h6>
        <OrderDetailsInputFields
          setFutureOrder={setEditedFutureOrder}
          futureOrder={editedFutureOrder}
          products={products || []}
          isEditable={true}
        />
      </div>
      <div className="flex flex-col flex-1"></div>
      <hr />
      <div className="flex flex-col flex-1"></div>
      <div>
        <ExpectedDeliveries isEditable={true} />
      </div>
      <FOModifyProductDeliveriesButtonSection
        backAction={backAction}
        nextAction={() =>
          SaveOrderDetailsAndRoute(setIsNextLoading, editedFutureOrder, accountId, nextAction, setEditedFutureOrder)
        }
        isNextLoading={isNextLoading}
      />
    </div>
  ) : null;
};

const SaveOrderDetailsAndRoute = async (
  setIsLoading: (_value: boolean) => void,
  editedFutureOrder: IFutureOrder,
  accountId: string,
  routeFunc: (_newId?: string) => void,
  setEditedFutureOrder: (_value: IFutureOrder) => void,
) => {
  setIsLoading(true);
  const savedUuid = await createFutureOrder(accountId, {
    ...editedFutureOrder,
    status: 'underwriting',
  });
  setIsLoading(false);
  setEditedFutureOrder({ ...editedFutureOrder, uuid: savedUuid?.uuid });
  routeFunc(savedUuid?.uuid);
};
